import React from "react";


const MainImage = ({
  src,
  alt,
  className,
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={` main-img-container ${className || ""}`}
    />
  );
};

export default MainImage;
